import { render } from "./WithIcon.vue?vue&type=template&id=2aa69d6f"
import script from "./WithIcon.vue?vue&type=script&lang=js"
export * from "./WithIcon.vue?vue&type=script&lang=js"
script.render = render

export default script